export default __webpack_public_path__ + "static/media/DtVnJx26TKEr37c9aBBx_kwFzg38pQhMruE-f2.f20dd9a2.woff2";